import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { requesterDetailsFormState, attendingAppointment } from "../../../features/CaptureDetailsSlice";
import IndividualDetails from "./IndividualDetails";
import { CaptureDetailsPrefixConstants, RequestorType } from "../../../models/Enums";
import { getIDDisplay, invalidRepresentativeDelegate, invalidTaxPractitionerDelegate } from "../../../features/Helper";

const DelegateDetails = () => {
    const captureDetailsForm = useSelector(requesterDetailsFormState);
    const attending = useSelector(attendingAppointment);

    const taxPractitionerIDTypeDisplay = getIDDisplay(captureDetailsForm?.values?.taxPractInfo_idType);
    const representativeIDTypeDisplay = getIDDisplay(captureDetailsForm?.values?.registeredRepresentInfo_idType);

    return (
        !attending && (captureDetailsForm?.values["requestorType"] === RequestorType.TaxPractitioner || captureDetailsForm?.values["requestorType"] === RequestorType.Representative) ? 
            <>
            <Typography sx={(theme) => ({ fontSize: theme.typography.h5, mt: "32px", pb: "8px" })}>
                Details of the Delegated Representative who will attend the appointment
            </Typography>
            <IndividualDetails prefix={CaptureDetailsPrefixConstants.Delegate}/>

            {invalidTaxPractitionerDelegate(captureDetailsForm) ? (
                <Typography
                sx={{ color: "#d32f2f", fontSize: "0.75rem", p: "8px 12px" }}
                >
                The {taxPractitionerIDTypeDisplay} provided cannot be the same for the Tax Practitioner, Taxpayer, or the Tax Practitioner's Delegate.
                </Typography>
            ) : null}

            {invalidRepresentativeDelegate(captureDetailsForm) ? (
                <Typography
                sx={{ color: "#d32f2f", fontSize: "0.75rem", p: "8px 12px" }}
                >
                The {representativeIDTypeDisplay} provided cannot be the same for the Representative, Taxpayer, or the Representative's Delegate.
                </Typography>
            ) : null}

            </> 
        : null
    );
};

export default DelegateDetails;
